import React from 'react';
import { APP_NAME, getLocale } from '@libs/constants';
import { EXTERNAL_LINKS } from '@libs/redirect.helper';
import { useTranslation } from 'next-i18next';
import { Icon, IconID } from '@common/Icon/Icon';
import { useBreakpoints } from '@hooks/useBreakpoints';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import type { SearchBoxProps } from '@layout/SearchBox/SearchBox';
import { useCartArticleCount } from '../hooks/useCartArticleCount';
import { CadSearchButton } from '@layout/CadSearch/CadSearchButton/CadSearchButton';

const DynamicSearchBox = dynamic<SearchBoxProps>(
  () => import('@layout/SearchBox/SearchBox').then(mod => mod.SearchBox),
  {
    ssr: false,
  }
);

export const Header: React.FC = () => {
  const { t } = useTranslation(['layout/header', 'toast/toast']);
  const { lg, available } = useBreakpoints();
  const router = useRouter();
  const locale = getLocale(router);
  const cartArticleCount = useCartArticleCount();

  const currentLogo = `/_${APP_NAME}/images/igus${locale === 'fr-FR' ? '-fr' : ''}-logo.svg`;

  return (
    <div className="flex container h-[69px] mt-0 px-2 justify-between text-base font-medium text-gray-400">
      <a className="ml-4" href={EXTERNAL_LINKS.SHOP_HOMEPAGE(locale)}>
        <img alt="igus" width="266" height="45" src={currentLogo} className="mt-2" data-testid="logo-image" />
      </a>
      {lg && available ? (
        <>
          <div className="flex mt-4 mr-9" style={{ width: 'calc(29.5% + 80px)' }}>
            <div className="flex-1 max-w-[calc(100%_-_80px)]">
              <DynamicSearchBox />
            </div>
            <CadSearchButton />
          </div>
          <div className="text-right mt-7 mr-4">
            <a className="text-right px-12 hover:text-black" href={EXTERNAL_LINKS.MYIGUS(locale)}>
              {t('HEADER.MYIGUS')}
            </a>
            <a className="px-12 py-4 whitespace-nowrap hover:text-black" href={EXTERNAL_LINKS.CART(locale)}>
              <span className="align-sub mr-4">
                <Icon id={IconID.CART} size={10} primary={false} />
              </span>
              <span>
                {t('FALLBACK_HEADER.SHOPPINGCART')} ({cartArticleCount})
              </span>
            </a>
          </div>
        </>
      ) : (
        <a className="px-12 py-4 pt-7 whitespace-nowrap" href={EXTERNAL_LINKS.CART(locale)}>
          <span className="align-middle mr-4">
            <Icon id={IconID.CART} size={10} primary={false} />
          </span>
          <span>({cartArticleCount})</span>
        </a>
      )}
    </div>
  );
};
